"use client"
/* */
import { propsContextSupportingComponents } from '../../components/propTypes/index.mjs';
import { mergeProps } from '@react-aria/utils';
import { resolveDynamicProps } from '../propsContext/dynamicProps/resolveDynamicProps.mjs';
import { useContextProps } from '../propsContext/propsContext.mjs';
import { wrapChildrenWithNestedPropsContext } from '../propsContext/nestedPropsContext/wrapChildrenWithNestedPropsContext.mjs';
import { omitBy } from 'remeda';
import { isDynamicProp } from '../propsContext/dynamicProps/isDynamicProp.mjs';
import { areChildrenEmpty } from '../react/areChildrenEmpty.mjs';

const useProps = (component, localProps) => {
  if ("children" in localProps) {
    if (areChildrenEmpty(localProps.children)) {
      localProps = { ...localProps };
      delete localProps["children"];
    }
  }
  const propsContext = useContextProps();
  const contextProps = propsContext[component];
  const withResolvedDynamicProps = contextProps ? resolveDynamicProps(contextProps, localProps) : void 0;
  const withNestedPropsContextProvider = contextProps ? wrapChildrenWithNestedPropsContext(contextProps, localProps) : void 0;
  const withoutNestedAndDynamicProps = contextProps ? omitBy(
    contextProps,
    (value, key) => propsContextSupportingComponents.includes(key) || isDynamicProp(value)
  ) : void 0;
  return mergeProps(
    withoutNestedAndDynamicProps,
    localProps,
    withResolvedDynamicProps,
    withNestedPropsContextProvider
  );
};

export { useProps as default, useProps };
//# sourceMappingURL=useProps.mjs.map
